import { Immutable } from '@zervant/reactcomponents'

import { ReducerBuilder } from './ReducerBuilder'

export const INITIAL_STATE = {
  emailInterval: null,
  vatPeriod: null,
}

function _assignSettings(state, payload) {
  return Immutable.copy(payload)
}

const reducer = ReducerBuilder.create(INITIAL_STATE)
  .mapAction('GET_COMPANY_SETTINGS', _assignSettings)
  .mapAction('UPDATE_COMPANY_SETTINGS', _assignSettings)
  .build()

export default reducer
